import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { legalAPI } from '../../../services/api';
import { getApiErrorMessage } from '../../../shared/utils/apiError';

export const fetchLegalStatus = createAsyncThunk(
  'legal/fetchStatus',
  async (_, { rejectWithValue }) => {
    try {
      return await legalAPI.getStatus();
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error));
    }
  }
);

export const acceptLegalDocuments = createAsyncThunk(
  'legal/accept',
  async (documentIds, { rejectWithValue }) => {
    try {
      return await legalAPI.accept(documentIds);
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error));
    }
  }
);

const initialState = {
  // null — not loaded yet; the consent window waits for the first status
  allAccepted: null,
  documents: [],
  loading: false,
  accepting: false,
  error: null,
};

const applyStatus = (state, status) => {
  state.allAccepted = !!status?.allAccepted;
  state.documents = status?.documents || [];
};

const legalSlice = createSlice({
  name: 'legal',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLegalStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLegalStatus.fulfilled, (state, action) => {
        state.loading = false;
        applyStatus(state, action.payload);
      })
      .addCase(fetchLegalStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(acceptLegalDocuments.pending, (state) => {
        state.accepting = true;
        state.error = null;
      })
      .addCase(acceptLegalDocuments.fulfilled, (state, action) => {
        state.accepting = false;
        applyStatus(state, action.payload);
      })
      .addCase(acceptLegalDocuments.rejected, (state, action) => {
        state.accepting = false;
        state.error = action.payload;
      });
  },
});

/** The window is needed only once the status is known and something active is not accepted. */
export const selectLegalConsentRequired = (state) => state.legal.allAccepted === false;

export default legalSlice.reducer;
